import qs from 'qs';
import { axiosAPI, axiosAPIv2 } from '@/plugins/axios';
import { qsOption } from '@/services/constants';
import videoIssuesMockData from '@/services/api/mockData/videoIssues.json';
import type {
  CursorProjectVideoListQuery,
  Filter,
  ListApiResponse, ListCursorApiResponse,
} from '@/modules/shared/types/axios.type';
import type { DeletedVideo, Video } from '@/modules/shared/types/video.type';
import type { VideoIssue } from 'src/modules/videoCaption';
import { RestoreDeletedVideoToProject } from '../types/projectVideoList.type';

const defaultVideoListFilter = {
  includes: ['creator', 'vod.source'],
};

export function loadVideosAPI(query: CursorProjectVideoListQuery) {
  const includes = [
    ...defaultVideoListFilter.includes,
  ];

  if (!query.projectKey) {
    includes.push('project');
  }

  const allQueries = qs.stringify({
    includes,
    ...query,
  }, qsOption);
  return axiosAPIv2.get<ListCursorApiResponse<Video[]>>(`/videos${allQueries}`);
}

export function loadVideoIssues(filter: Filter) {
  const query = qs.stringify({ ...defaultVideoListFilter, ...filter }, qsOption);
  return axiosAPI.get(`/video-issues${query}`);
}

export function loadVideoCaptionIssues(filter: Filter, useMockData = false) {
  if (useMockData) {
    return {
      data: {
        total: 3,
        lastPage: 1,
        data: videoIssuesMockData,
      },
    };
  }

  const query = qs.stringify({ ...filter }, qsOption);
  return axiosAPI.get<ListApiResponse<VideoIssue[]>>(`/videos-issues/captions${query}`);
}

export function loadRecentlyDeleted(filter: Filter) {
  const query = qs.stringify({ ...filter }, qsOption);
  return axiosAPI.get<ListApiResponse<Array<DeletedVideo>>>(`/deleted-videos${query}`);
}

export function restoreDeletedVideo(videoKey: string) {
  return axiosAPI.put(`/deleted-videos/restore/${videoKey}`);
}

export function restoreAllDeletedVideos(projectKey: string) {
  return axiosAPI.put(`/deleted-videos/restore/projects/${projectKey}`);
}

export function restoreDeletedProject(projectKey: string, filter?: Filter) {
  const query = qs.stringify({ ...filter }, qsOption);
  return axiosAPI.put(`/projects/${projectKey}/restore${query}`);
}

export function restoreDeletedVideoToProject(videoKey: string, payload: RestoreDeletedVideoToProject) {
  return axiosAPI.put(`/deleted-videos/restore/${videoKey}`, payload);
}
